export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Is Yoga Teaching Vault™ a physical product?',
    answer:
      'No. Yoga Teaching Vault™ is a 100% digital product delivered in PDF format. Nothing is physically shipped.',
  },
  {
    question: 'How do I receive it?',
    answer:
      'After completing your purchase, you’ll receive access according to the digital delivery method shown at checkout.',
  },
  {
    question: 'Is this only for new yoga teachers?',
    answer:
      'No. New teachers may especially appreciate the structure, scripts and Confidence Kit, while experienced teachers can use the Vault to reduce planning time, create more variety and have backup classes ready.',
  },
  {
    question: 'Do I have to teach the classes exactly as written?',
    answer:
      'No. The Vault gives you a ready-to-use starting structure. You remain the teacher and can adapt the material appropriately to your teaching context, training, students and professional scope.',
  },
  {
    question: 'What styles are included?',
    answer:
      'The core library includes Beginner & Gentle Yoga, Hatha, Slow Flow & Accessible Vinyasa, Mobility, Restorative/Yin-inspired/breath-based practices, Chair Yoga, mixed-level and adaptable classes.',
  },
  {
    question: 'Are there classes for beginners?',
    answer:
      'Yes. Volume 01 focuses specifically on beginner and gentle teaching, and additional modification and mixed-level resources are included elsewhere in the Vault.',
  },
  {
    question: 'What if I need a class at the last minute?',
    answer:
      'That’s exactly why 30 Emergency Ready-to-Teach Classes™ is included. You can also use The 60-Second Class Finder™ to quickly identify an appropriate class from the library.',
  },
  {
    question: 'Can I use it when I’m substituting for another teacher?',
    answer:
      'Yes. The Vault includes adaptable and emergency options designed to make last-minute class preparation easier.',
  },
  {
    question: 'Can I use the PDFs from my phone or tablet?',
    answer:
      'Yes. The product is designed as a digital PDF library, making it convenient to reference from common devices that support PDFs.',
  },
  {
    question: 'Can I print it?',
    answer:
      'You can print pages for your own personal teaching reference, subject to the license terms provided with the product.',
  },
  {
    question: 'Does this replace yoga teacher training?',
    answer:
      'No. Yoga Teaching Vault™ is a planning and teaching resource. It does not replace professional yoga teacher education, appropriate qualifications, experience or judgment.',
  },
  {
    question: 'Does it provide medical advice?',
    answer:
      'No. The Vault is an educational teaching resource and is not a substitute for individualized medical advice, diagnosis, rehabilitation or treatment.',
  },
  {
    question: 'Can I share or resell the PDFs?',
    answer:
      'No, unless your license explicitly states otherwise. Your purchase is intended for your own use as the purchaser.',
  },
]
